
import React from 'react';
import { BrowserRouter, Navigate, Route } from 'react-router-dom';

import { ThemeProvider } from '../../../shared/ThemeContext';
import { AuthProvider } from '../../../shared/AuthContext';


const Factory = () => {

  const App = require( '../../../app' ).default;
  
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <App.Data.Domain model={App.model} >
            <Route path="*" element={<Navigate replace to="/" />} />
          </App.Data.Domain>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
};


export default Factory;